import React, { Dispatch, JSX, SetStateAction, ReactElement, useState, useRef, useEffect } from 'react';
import { Sheet, SheetRef } from 'react-modal-sheet';
import { Box } from '@mui/material';

import './BottomSheet.css';

export function BottomSheet({
  children,
  header,
  bottomSheetUp,
  setBottomSheetUp,
  routeTab,
}: {
  children: ReactElement | undefined;
  header?: JSX.Element | undefined;
  bottomSheetUp?: boolean;
  setBottomSheetUp: Dispatch<SetStateAction<boolean>>;
  routeTab?: boolean;
}) {
  const sheetRef = useRef<SheetRef>(null);
  const headerRef = useRef<HTMLElement | null>(null);
  const INITIAL_SNAP = 2;
  const SNAP_POINTS = [0, 125, 336, 1];
  const [snapValue, setSnapValue] = useState(SNAP_POINTS[INITIAL_SNAP]);

  useEffect(() => {
    if (bottomSheetUp) {
      sheetRef.current?.snapTo(INITIAL_SNAP);
    }
  }, [bottomSheetUp]);

  function handleSnap(snapIndex: number) {
    const snapPointValue = sheetRef.current?.snapPoints[snapIndex]?.snapValue ?? 0;
    const headerHeight = headerRef.current?.clientHeight ?? 0;
    setSnapValue(Math.max(snapPointValue - headerHeight, 0));
    setBottomSheetUp(snapIndex !== 1);
  }

  return (
    <Sheet
      ref={sheetRef}
      isOpen={true}
      onClose={() => {}}
      onSnap={handleSnap}
      initialSnap={INITIAL_SNAP}
      disableDismiss={true}
      snapPoints={SNAP_POINTS}
    >
      <Sheet.Container
        style={{ '--sheet-height': `calc(${snapValue}px - var(--bottom-nav-bar-height))` } as React.CSSProperties}
        data-qa-element-id="bottom_sheet"
      >
        <Sheet.Header className={routeTab ? 'routes-summary-header' : ''}>
          <Box ref={headerRef}>
            <Box sx={{ p: 1, display: 'flex', justifyContent: 'center' }}>
              <Sheet.DragIndicator />
            </Box>
            {header}
          </Box>
        </Sheet.Header>
        <Sheet.Content>{children}</Sheet.Content>
      </Sheet.Container>
    </Sheet>
  );
}
